// extracted by mini-css-extract-plugin
export default {"wrapper":"Ns-z","viewport":"Os-z","container":"Ps-z","slide":"Qs-z"};